export default {"src":"/_next/static/media/myspace.7125cd63.svg","height":60,"width":100};